document.addEventListener('click',function(e){const t=e.target.closest('[data-menu-toggle]');if(t){const nav=document.querySelector('[data-mobile-nav]');if(nav){nav.hidden=!nav.hidden;t.setAttribute('aria-expanded',String(!nav.hidden));}}});

document.addEventListener('click',function(e){
  const thumb=e.target.closest('[data-product-thumbnail]');
  if(!thumb)return;
  const gallery=thumb.closest('.product-gallery');
  if(!gallery)return;
  const main=gallery.querySelector('[data-product-main-image]');
  if(!main)return;
  main.src=thumb.getAttribute('data-full-src');
  main.alt=thumb.getAttribute('data-alt')||'Produktbild';
  gallery.querySelectorAll('[data-product-thumbnail]').forEach(function(btn){
    btn.classList.toggle('is-active',btn===thumb);
    btn.setAttribute('aria-pressed',String(btn===thumb));
  });
});
